import { Routes } from '@angular/router';
import { loginGuard } from './core/guards/login.guard';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
    {
        path: "",
        loadChildren: () => import('./main/main.module').then(module => module.MainModule),
        canActivate: [authGuard],
        
    },
    {
        path: "auth",
        loadChildren: () => import('./auth/auth.module').then(module => module.AuthModule),
        canActivate: [loginGuard]
    },
    // {
    //     path: "**",
    //     redirectTo: "/auth"
    // }
];
